import React from 'react';
import { useShowLocationSelectorModal } from '@app/locationSelector';
import WhereAreYouModal from './components/WhereAreYouModal';

const WhereAreYou = () => {
  const showLocationSelectorModal = useShowLocationSelectorModal();

  if (!showLocationSelectorModal) {
    return null;
  }

  return <WhereAreYouModal />;
};

export default WhereAreYou;
